import banner1 from '../assets/images/3sc/Banner 1.png';
import banner2 from '../assets/images/3sc/Banner 2.png';
import banner3 from '../assets/images/3sc/Banner 3.png';
import coin from '../assets/icons/coin.svg';
import flag from '../assets/icons/flag.svg';
import clock from '../assets/icons/clock.png';

export const imageConstants = {
  banner1,
  banner2,
  banner3,
};

export const icons = {
  coin,
  flag,
  clock,
}

export const faqData = [
    {
      question: "What is the 3S Certificate?",
      answer: "A sustainability certification and badge, aligned to the UN SDGs and verified by Suspire’s rigorous framework across parameters, so shoppers, retailers, and investors trust your eco‑claims in a single glance."
    },
    {
      question: "What is the difference between the Standard 3S Certification Badge and the A+ Gold Badge?",
      answer: "Brands with the standard 3S Badge meet our core sustainability standards. Those with the A+ Gold Badge go a step further, achieving excellence across all sustainability parameters."
    },
    {
      question: "How long is it valid?",
      answer: "12 months from the date of issue."
    },
    {
      question: "What does the score mean?",
      answer: "It reflects the extent and strength of your sustainable practices, based on submitted proof."
    },
    {
      question: "Can I reapply later?",
      answer: "Yes, post-expiry or via \"Regenerate Score\" button with admin approval."
    },
    {
      question: "Will I get feedback on my submission?",
      answer: "Yes, you'll receive clear strengths, improvement areas, and recommendations."
    },
    {
      question: "Where can I use the badge?",
      answer: "On your website, LinkedIn, packaging, and marketing."
    },
    {
      question: "Do I need to submit proof?",
      answer: "Yes, all answers must be backed with documentation for validation."
    },
    {
      question: "How long does the whole process take?",
      answer: "Typically 2–3 business days post submission."
    },
    {
      question: "What if I update my sourcing practices?",
      answer: "You can notify us and request to regenerate your score."
    },
    {
      question: "Is this mandatory for listing on suspire?",
      answer: "No, but certified brands get enhanced visibility, trust, and conversion."
    }
  ];

  export const timelineSteps = [
    {
      number: 1,
      title: "Fill out your questionnaire",
      description: "Complete a comprehensive assessment covering all aspects of your sustainability practices."
    },
    {
      number: 2,
      title: "Upload supporting proof",
      description: "Provide documentation and evidence to validate your sustainability claims."
    },
    {
      number: 3,
      title: "Get reviewed and scored",
      description: "Our experts review your submission and assign your sustainability score."
    },
    {
      number: 4,
      title: "Receive your badge & use it everywhere",
      description: "Get your official 3SC badge and start showcasing your sustainability credentials."
    }
  ];

  export const benefitsData = {
    brand: [
      "Instant Credibility",
      "Higher Conversion",
      "Preferential PR Access"
    ],
    customers: [
      "Trust in verified claims",
      "Reduces greenwashing",
      "Confidence to buy consciously"
    ],
    marketplace: [
      "Elevates platform integrity",
      "Enables data-led storytelling",
      "Improves retail acceptance"
    ]
  };

  export const whySectionData = [
    {
      title: "Credi‑Ability",
      description: "73 % of shoppers drop carts over vague eco‑claims. A 3S badge answers “How green is this?” before they ask."
    },
    {
      title: "Profit‑Ability",
      description: "Brands displaying “A+” Grade have a higher chance of add‑to‑cart in our pilot. Retail buyers list “third‑party certifications” as a top‑3 listing criterion."
    },
    {
      title: "Visi‑Ability",
      description: "Brands get priority placement, shout‑outs, & media features scaled to their grade tier."
    }
  ];